import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from '../Icon/Icon';
import ArrowLeft from '../../assets/svg/ArrowLeft.svg';
import ArrowRight from '../../assets/svg/ArrowRight.svg';
import * as styles from './Slider.css';

const cx = classNames.bind(styles);

export class Slider extends Component {
    static defaultProps = {
        wrapperClass: '',
        contentWrapperClass: '',
        deviceType: {
            isDesktop: false,
        },
        customLeftButtonSliderClass: '',
        customRightButtonSliderClass: '',
    };

    static propTypes = {
        wrapperClass: PropTypes.string,
        children: PropTypes.element.isRequired,
        contentWrapperClass: PropTypes.string,
        deviceType: PropTypes.object,
        customLeftButtonSliderClass: PropTypes.string,
        customRightButtonSliderClass: PropTypes.string,
    };

    state = {
        disableLeftArrow: true,
        disableRightArrow: false,
        animateWrapperClass: {},
    };

    componentDidMount() {
        if (!this.isDesktop()) return;
        this.disableArrowCheck();
        window.addEventListener('scroll', this.onScrollTransition.bind(this));
        window.addEventListener('resize', this.onResizeCallback.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const { children = {} } = this.props;
        const { children: nextPropsChildren = {} } = nextProps || {};
        if (this.isDesktop() && nextPropsChildren !== children) {
            this.scrollPosition = 0;
            this.disableArrowCheck();
        }
    }

    componentWillUnmount() {
        if (!this.isDesktop()) return;
        if (!__SERVER__) {
            window.removeEventListener('scroll', this.onScrollTransition.bind(this));
            window.removeEventListener('resize', this.onResizeCallback.bind(this));
        }
    }

    onResizeCallback = () => {
        this.disableArrowCheck();
    };

    onScrollTransition = () => {
        // pageYOffset is compatable with all browsers
        const currentScrollTop = window.pageYOffset;
        const { disableLeftArrow, disableRightArrow } = this.state;

        if (this.isComponentVisible() && !(disableLeftArrow && disableRightArrow)) {
            const wrapperTransitionClass =
                this.previousScrollTop > currentScrollTop ? 'animateRight' : 'animateLeft';
            this.setState({
                animateWrapperClass: wrapperTransitionClass,
                animateButtonsClass: 'addButtonAnimation',
            });
        } else {
            this.setState({ animateButtonsClass: 'removeButtonAnimation' });
        }
        this.previousScrollTop = currentScrollTop;
    };

    getDimensions() {
        if (!this.wrapperRef || !this.listParentRef) return {};
        const { width: wrapperWidth } = this.wrapperRef.getBoundingClientRect() || {};
        const { scrollWidth: parentWidth, childElementCount } = this.listParentRef;
        return {
            wrapperWidth,
            parentWidth,
            childElementCount,
        };
    }

    getListParentRef = (ref) => {
        this.listParentRef = ref;
    };

    isDesktop = () => {
        const { deviceType: { isDesktop = false } = {} } = this.props;
        return isDesktop;
    };

    scrollPosition = 0;

    listParentRef = null;

    isComponentVisible = () => {
        if (!this.listParentRef) return false;
        const { top = 0, height = 0 } = this.listParentRef.getBoundingClientRect() || {};
        const { innerHeight } = window;
        const { documentElement: { clientHeight } = {} } = document;
        const windowInnerHeight = innerHeight || clientHeight || 0;
        const heightPoint = height / 4;
        const showContent =
            top + height - heightPoint <= windowInnerHeight && top + heightPoint >= 0;
        return showContent;
    };

    scrollCartridge = (scrollToRight) => {
        const { wrapperWidth = 0, parentWidth = 0 } = this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        if (scrollToRight) {
            const newScrollPosition = this.scrollPosition - wrapperWidth;
            this.scrollPosition =
                newScrollPosition >= maxMoveToRight ? newScrollPosition : maxMoveToRight;
        } else {
            const newScrollPosition = this.scrollPosition + wrapperWidth;
            this.scrollPosition =
                newScrollPosition <= maxMoveToLeft ? newScrollPosition : maxMoveToLeft;
        }
        if (this.listParentRef)
            this.listParentRef.style.transform = `translate(${this.scrollPosition}px)`;
        this.disableArrowCheck();
    };

    disableArrowCheck = () => {
        const { wrapperWidth = 0, parentWidth = 0, childElementCount = 0 } =
            this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        const rightArrowCheck = this.scrollPosition <= maxMoveToRight || childElementCount <= 4;
        const leftArrowCheck = this.scrollPosition >= maxMoveToLeft || childElementCount <= 4;
        this.setState({
            animateWrapperClass: (rightArrowCheck || leftArrowCheck) && '',
            disableRightArrow: rightArrowCheck,
            disableLeftArrow: leftArrowCheck,
        });
    };

    renderNavigationButtons = () => {
        const { disableLeftArrow, disableRightArrow, animateButtonsClass } = this.state;
        const leftArrowClass = cx({ iconClass: true, disabledArrow: disableLeftArrow });
        const rightArrowClass = cx({ iconClass: true, disabledArrow: disableRightArrow });
        if (disableLeftArrow && disableRightArrow) return null;
        const { customLeftButtonSliderClass, customRightButtonSliderClass } = this.props;
        return (
            <>
                <button
                    className={cx(
                        'arrow',
                        'leftArrow',
                        customLeftButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableLeftArrow}
                    onClick={() => this.scrollCartridge(false)}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={leftArrowClass}
                    >
                        <ArrowLeft />
                    </Icon>
                </button>
                <button
                    className={cx(
                        'arrow',
                        'rightArrow',
                        customRightButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableRightArrow}
                    onClick={() => this.scrollCartridge(true)}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={rightArrowClass}
                    >
                        <ArrowRight />
                    </Icon>
                </button>
            </>
        );
    };

    render() {
        const { wrapperClass, contentWrapperClass, children } = this.props;
        const { animateWrapperClass } = this.state;
        const extraPropsToChildren = this.isDesktop()
            ? {
                  listParentRef: this.getListParentRef,
              }
            : {};
        const wrapperClassOndeviceType = !this.isDesktop() && 'mobileSlider';
        const childrenElement = React.cloneElement(children, extraPropsToChildren);
        return (
            <div className={cx('sliderWrapper', wrapperClass, wrapperClassOndeviceType)}>
                <div
                    className={cx('contentWrapper', contentWrapperClass, animateWrapperClass)}
                    ref={(el) => {
                        this.wrapperRef = el;
                    }}
                >
                    {childrenElement}
                </div>
                {this.listParentRef && this.isDesktop() && this.renderNavigationButtons()}
            </div>
        );
    }
}

export default Slider;
